import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { notification, FRONTEND_BASE_URL, openEmbedCodePreview } from "../../../utils/utility";
import { connect } from "react-redux";
import { getCompanyData } from "../../../actions/companyActions";
import Loader from "../../../components/Loader/Loader";
import ClrPicker from "../../../views/events/Components/Fields/ClrPicker";
import Tooltip from "../../../components/Tooltip";
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import { fetchUserFeatures } from "../../../actions/featureAccessActions";
import { hasAddOctoLinkWebsite } from "../../../utils/featureAccessHelpers";
import isEmpty from "../../../validation/is-empty";

class EmbedCodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      companySlug: "",
      pageLoading: false,
      backgroundColor: "default",
      textColor: "default",
      buttonColor: "default",
    };
  }

  /**
   * executed when component is inserted in dom
   */
  componentDidMount() {
    const { getCompanyData, fetchUserFeatures, featuresLoaded, featuresLoading } =
      this.props;

    if (!featuresLoaded && !featuresLoading) {
      fetchUserFeatures();
    }

    this.setState({
      pageLoading: true,
    });

    const _this = this;

    getCompanyData({
      data: {},
      onSuccess: function (details) {
        _this.setState({
          pageLoading: false,
          companySlug: details.url_slug,
        });
      },
      onError: function (error) {
        _this.setState({
          pageLoading: false,
        });
      },
    });
  }

  toggle = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
    this.props.hideEmbedCodeModal();
  };

  /**
   * on copy code
   */
  onCopyCode = () => {
    if (!hasAddOctoLinkWebsite(this.props.features)) {
      return;
    }

    var copyText = document.getElementById("share-company-element");
    copyText.select();
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    notification.success(`Code copied successfully`);
  };

  /**
   *
   */
  onPreview = () => {
    if (!hasAddOctoLinkWebsite(this.props.features)) {
      notification.warning("Upgrade your plan to preview embed code.");
      return;
    }

    const embedCode = document.getElementById("share-company-element");
    if (!embedCode || isEmpty(embedCode.value)) {
      notification.error("Embed code is not ready yet.");
      return;
    }

    openEmbedCodePreview(embedCode.value);
  };

  render() {
    const { isOpen, pageLoading } = this.state;
    const _this = this;
    const { features, featuresLoaded } = this.props;
    const embedAllowed =
      featuresLoaded && hasAddOctoLinkWebsite(features);

    const { companySlug, backgroundColor, textColor, buttonColor } = this.state;
    let content = "";

    if (embedAllowed && companySlug) {
      const dataConfig = {
        "company-url": companySlug,
        "background-color": backgroundColor,
        "text-color": textColor,
        "button-color": buttonColor,
        type: "company",
      };
      content =
        "<div id='meetocto-booking-widget' data-config='" +
        JSON.stringify(dataConfig) +
        "'></div>";
      content +=
        '<link rel="stylesheet" href="' +
        FRONTEND_BASE_URL +
        'embeddable-widget/widget.css" />';
      content +=
        '<script type="text/javascript" src="' +
        FRONTEND_BASE_URL +
        'embeddable-widget/widget.js"></script>';
    }

    return (
      <>
        <Loader isShowLoader={pageLoading} />
        {!pageLoading && (
          <Modal
            isOpen={isOpen}
            toggle={this.toggle}
            className="event-modal embed_code_modal modal-lg modal-dialog"
          >
            <ModalHeader>
              Share Company Page
              <Tooltip code="P17F1" />
            </ModalHeader>
            <ModalBody>
              <div className="">
                <div className="row mx-0 flex-column-reverse flex-md-row">
                  <div className="col-md-5 clr_settings">
                    <div className="inner">
                      <h4>Page Settings</h4>
                      <p>
                        Customize the look of your booking page to fit
                        seamlessly into your website.
                      </p>
                      <div className="clr_field_width d-flex align-items-center justify-content-between">
                        <label className="form-label">Background color</label>
                        <ClrPicker
                          onColorPickerChange={(color) => {
                            _this.setState({ backgroundColor: color });
                          }}
                          value={_this.state.backgroundColor}
                        />
                      </div>
                      <div className="clr_field_width d-flex align-items-center justify-content-between">
                        <label className="form-label">Text color</label>
                        <ClrPicker
                          onColorPickerChange={(color) => {
                            _this.setState({ textColor: color });
                          }}
                          value={_this.state.textColor}
                        />
                      </div>
                      <div className="clr_field_width d-flex align-items-center justify-content-between">
                        <label className="form-label">
                          Button and link color
                        </label>
                        <ClrPicker
                          onColorPickerChange={(color) => {
                            _this.setState({ buttonColor: color });
                          }}
                          value={_this.state.buttonColor}
                        />
                      </div>

                      <div className="clr_picker d-flex align-items-center mt-5">
                        <button
                          className="btn btn-grey mr-2"
                          onClick={_this.onPreview}
                          disabled={!embedAllowed}
                        >
                          Preview
                        </button>
                        <button
                          className="btn btn-grey ml-2"
                          onClick={(event) => {
                            event.preventDefault();
                            _this.setState({
                              backgroundColor: "default",
                              textColor: "default",
                              buttonColor: "default",
                            });
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 code">
                    <div className="eventdetailsaddbox rd_modalvieewdashboard">
                      <div className="box_content rd_modalboxcontent">
                        <div className="rd_emebedparinmodl">
                          <h4>Embed Code</h4>
                          <p>
                            Place this code in your page's HTML where you
                            <br />
                            want your company page to appear.
                          </p>

                          <FeatureLock
                            featureId={FEATURE_IDS.ADD_OCTOLINK_WEBSITE}
                            maskContent
                          >
                            <textarea
                              name=""
                              cols="30"
                              rows="10"
                              id="share-company-element"
                              readOnly={true}
                              value={content}
                            ></textarea>
                          </FeatureLock>

                          <p style={{ display: "none" }}>
                            See how to embed your Meetocto link across the web,
                            including sites like
                            <a href="">Wix</a>
                            <a href=""> Squarespace</a>
                            and <a href="">WordPress</a>. Or explore
                            <a href="">advanced embed features .</a>
                          </p>
                          <div className="rd_dashboardmodalfooterpart">
                            <div></div>
                            <div className="rd_dashboardmodalfooterpartb">
                              <button
                                onClick={this.toggle}
                                className="btn btn-outline"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={this.onCopyCode}
                                className="btn btn-app"
                                disabled={!embedAllowed}
                              >
                                Copy Code
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    features: state.featureAccess.features,
    featuresLoaded: state.featureAccess.loaded,
    featuresLoading: state.featureAccess.loading,
  }),
  {
    getCompanyData,
    fetchUserFeatures,
  }
)(EmbedCodeModal);
